<template>
  <div class="container">
    <div class="card-login card-container">
      <center>
        <img class="egas-login-logo" id="profile-img" src="@/assets/img/egas-logo-color.png" alt="eGas" />
        <div class="egas-login-product">QSStorage</div>
      </center>
      <p id="profile-name" class="profile-name-card"></p>
      <center>
        <div v-if="alert" class="alert alert-info" role="alert">
          {{ alert }}
        </div>
        <div v-if="error" class="alert alert-warning" role="alert">
          {{ error }}
        </div>
      </center>
      <form class="form-signin" @submit.prevent="checkCreds">
        <span id="reauth-email" class="reauth-email"></span>
        <input type="text" id="inputEmail" class="form-control" placeholder="Usuario" required autofocus
          v-model="username" />
        <input type="password" id="inputPassword" class="form-control" placeholder="Contraseña" required
          v-model="password" />
        <button class="btn btn-lg btn-info btn-block btn-signin" type="submit">
          Iniciar Sesión
        </button>
        <router-link :to="{ path: '/restore' }" style="font-size: 11px">
          ¿Olvidaste tu contraseña?
        </router-link>
      </form>
    </div>
  </div>
</template>

<script>
import auth from '../token'
import api from '../api'
import Cookies from 'js-cookie'
export default {
  name: "Login",
  data(router) {
    return {
      username: "",
      password: "",
      error: "",
      alert: ""
    };
  },
  mounted() {
    this.error = localStorage.getItem('msg');
    this.alert = "";
    localStorage.removeItem('role');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('station');
    localStorage.removeItem('user');
    localStorage.removeItem('stationId');
    localStorage.removeItem('stationName');
    localStorage.removeItem('attributes');
    localStorage.removeItem('token');
    const clearCacheData = () => {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name)
        })
      })
    }
    clearCacheData()
  },
  methods: {
    async checkCreds() {
      this.alert = "Verificando datos, por favor espere";
      this.error = "";
      const { username = "", password = "" } = this;

      try {
        const resp = await api.request(
          'POST',
          `/login/token`,
          {
            username: username,
            password: password
          }
        );

        this.alert = '';
        if (resp.data && resp.data.data) {
          const { token, refresToken, userInfo, attributesRol } = resp.data.data;
          auth.setUserLogged(username);
          auth.setUserToken(token);
          auth.setRefreshToken(refresToken);
          localStorage.setItem('token', token);
          localStorage.setItem('refreshToken', refresToken);
          localStorage.setItem('user', username);
          localStorage.setItem('attributes', JSON.stringify(attributesRol[0].attributes));
          const station = userInfo.estacion ? userInfo.estacion[0] : null;
          auth.setStationNumber(station);
          localStorage.setItem('station', station);
          Cookies.set('userEmail', userInfo.email);
          Cookies.set('userName', username);

          if (userInfo.roles && userInfo.roles.length > 1) {
            for (let i = 0; i < userInfo.roles.length; i++) {
              if (userInfo.roles[i] === 'ADMIN') {
                localStorage.setItem('role', 'ADMIN')
                i = userInfo.roles.length
              } else {
                localStorage.setItem('role', userInfo.roles[i])
              }
            }
          } else {
            localStorage.setItem('role', userInfo.roles ? userInfo.roles[0] : null)
          }
          window.location = '/dashboard';
        }

      } catch (error) {
        this.error = 'Usuario/Conraseña incorrecto';
      }
    },
  }
};
</script>

<style>
.login {
  max-height: 200px;
  max-width: 150px !important;
  width: 150px !important;
  height: 200px;
  min-height: 50px;
  min-width: 100px;
}

body {
  background-image: url("../assets/img/fondo-login.jpg");
}

.card-container.card-login {
  border-radius: 20px;
  width: 350px;
  padding: 40px 40px;
}

.btn {
  font-weight: 700;
  height: 36px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
}

/*
 * Card component
 */
.card-login {
  background-color: #f7f7f7;
  /* just in case there no content*/
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 60px;
  /* shadows and rounded borders */
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

/*
 * Form styles
 */
.profile-name-card {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 10px 0 0;
  min-height: 1em;
}

.reauth-email {
  display: block;
  color: #404040;
  line-height: 2;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin #inputEmail,
.form-signin #inputPassword {
  direction: ltr;
  height: 44px;
  font-size: 16px;
}

.form-signin input[type="email"],
.form-signin input[type="password"],
.form-signin input[type="text"],
.form-signin button {
  width: 100%;
  display: block;
  margin-bottom: 10px;
  z-index: 1;
  position: relative;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin .form-control:focus {
  border-color: rgb(104, 145, 162);
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgb(104, 145, 162);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgb(104, 145, 162);
}

.btn.btn-signin {
  padding: 0px;
  font-weight: 700;
  font-size: 14px;
  height: 36px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: none;
  -o-transition: all 0.218s;
  -moz-transition: all 0.218s;
  -webkit-transition: all 0.218s;
  transition: all 0.218s;
}
</style>
